<template>
  <div :class="'sitebuilder-element-container is-receiver' + hideControl()"
       element="BoxComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile" :id="id"


       :style="style()">

      <div v-bind:style="{
       'border-radius': radius,
        background: background,
        height : height,
        width : width,
        border : border,
        'box-shadow': boxShadow,
       }"
           class="sitebuilder-element-receiver">
        <component v-for="(element,index) in elements" :is="element.name" :config="element.config" :key="index"
                   :id="element.id" :height_start="index" :preview="preview"></component>
      </div>
  </div>
</template>
<script>

	import Model from './Model';

	import ImageComponent from "../Image/Image.vue";
	import TextComponent from "../Text/Text.vue";
	import ButtonComponent from "../Button/Button.vue";
    import MailingBossFormComponent from "../Forms/MailingBossForm/MailingBossForm";
    import SimpleFormComponent from "../Forms/SimpleForm/SimpleForm";

    import YoutubeVideoComponent from "../YoutubeVideo/Youtube";
	import IframeComponent from "../Iframe/Iframe";
	import MenuComponent from "../Menu/Menu";

	export default {
		name: 'BoxComponent',
		components: {
			MenuComponent,
			IframeComponent,
			YoutubeVideoComponent,
			MailingBossFormComponent,
			Model,
			ImageComponent,
			TextComponent,
			ButtonComponent,
            SimpleFormComponent
		},
		props: ['config', 'childs', 'height_start', 'device', 'id', 'preview'],
		data() {
			return Model.data()
		},
		computed: {
			width() {
				return this.internal_config.width;
			},
			height() {
				return this.internal_config.height;
			},
			border() {
				return this.internal_config.border;
			},
			boxShadow() {
				return this.internal_config.boxShadow;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
			// bg-color bg-image position/bg-size bg-repeat bg-origin
			background() {
				let bg = this.internal_config.backgroundColor;


				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					bg += ' url("' + this.internal_config.backgroundImage + '")';
					bg += ' ' + this.internal_config.backgroundPosition;
					bg += ' / ' + this.internal_config.backgroundSize;
					bg += ' ' + this.internal_config.backgroundRepeat;
					bg += ' ' + this.internal_config.backgroundOrigin;
				}


				return bg;
			},
		},
		methods: {

			 hideControl(){
				 var classAdd = '';
				if(!this.internal_config.showMobile){
					classAdd = classAdd + ' hide-on-mobile'
				}

				if(!this.internal_config.showDesktop){
					classAdd = classAdd + ' hide-on-desktop'
				}

				return classAdd;
			 },

			style() {


				let style = `left:  ${this.internal_config.left};
                     padding-top: ${this.internal_config.paddingTop};
                     padding-left: ${this.internal_config.paddingLeft};
                     z-index: ${this.internal_config.zIndex};
                     padding-right: ${this.internal_config.paddingRight};
                     padding-bottom: ${this.internal_config.paddingBottom};
                     top: ${this.internal_config.top}`;
				return style;
			},
		},
		mounted() {
			let device, childs, id, config;
			({device, childs, id, config} = this.$props);

			if (typeof config.backgroundColor === 'undefined') {
				config.backgroundColor = '#FFFFFF';
			}
			this.internal_config = config;
			this.device = device;

			if (typeof childs === 'undefined') {
				childs = [];
			}
			this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
			if (typeof id !== 'undefined') {
				this.id = id;
			}

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

		}
	}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @media (max-width: 980px) {
    .sitebuilder-element-receiver {
      max-width: 100% !important;
      width: 100% !important;
      height: auto !important;
      min-height: 50px;
    }
  }
</style>
